import * as fetch from "../../common/fetch";

import { PolicyCreateRequestType, PolicyDeleteRequestType } from "../requests/policyRequestTypes";
import { UserGetPoliciesResponseType } from "../responses/userResponseTypes";
import { GroupGetPoliciesResponseType } from "../responses/groupResponseTypes";

import {
  PolicyGetResponseType,
  PolicyGetAllResponseType,
  PolicyGetRolesResponseType
} from "../responses/policyResponseTypes";

const url = process.env.WIB_API_URL;

export async function getAll() {
  const response = await fetch.get(`${url}/policies`);

  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as PolicyGetAllResponseType;
  }
}

export async function getById(id) {
  const response = await fetch.get(`${url}/policies/${id}`);
  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as PolicyGetResponseType;
  }
}

export async function create(body: PolicyCreateRequestType) {
  const response = await fetch.post(`${url}/policies`, body);
  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as PolicyGetResponseType;
  }
}

export async function update(id, body: PolicyCreateRequestType) {
  const response = await fetch.put(`${url}/policies/${id}`, body);
  return response.ok;
}

export async function del(id, body: PolicyDeleteRequestType) {
  const response = await fetch.del(`${url}/policies/${id}`, body);
  return response.ok;
}

export async function getUsers(id) {
  const response = await fetch.get(`${url}/policies/${id}/users`);
  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as UserGetPoliciesResponseType;
  }
}

export async function getRoles(id) {
  const response = await fetch.get(`${url}/policies/${id}/roles`);
  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as PolicyGetRolesResponseType;
  }
}

export async function getGroups(id) {
  const response = await fetch.get(`${url}/policies/${id}/groups`);

  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as GroupGetPoliciesResponseType;
  }
}
